// extracted by mini-css-extract-plugin
module.exports = {"quick-filters-container":"filters_quick-filters-container__2cuP1","quick-filters":"filters_quick-filters__Ugr9s","quick-filters-label":"filters_quick-filters-label__3zlNE"};